import { HttpClient, HttpResponse } from '@angular/common/http';
import { ServicesHelper } from '../helpers/services.helper';
import { Observable } from 'rxjs';

export abstract class BaseService<T> {
  constructor(protected apiUrl: string, protected url: string, protected httpClient: HttpClient) {}

  public get(): Observable<Array<T>> {
    const response: Observable<Array<T>> = this.httpClient.get<Array<T>>(this.url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });

    return response;
  }

  public getById(id: string): Observable<T> {
    const url = this.url + id;
    const response: Observable<T> = this.httpClient.get<T>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }

  public post(entity: T): Observable<T> {
    const response: Observable<T> = this.httpClient.post<T>(this.url, entity, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }

  public put(entity: T): Observable<T> {
    const response = this.httpClient.put<T>(this.url, entity, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }

  public delete(id: string): Observable<HttpResponse<T>> {
    const url = this.url + id;
    const response = this.httpClient.delete<HttpResponse<T>>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }
}
